import React, { Component } from 'react';
import DataTable from '../../../../components/DataTable/index';
import PropTypes from 'prop-types';
import $ from 'jquery';

class TrustListGrid extends Component {
    componentWillUnmount() {
        let { updateSelected } = this.props;
        updateSelected({});
    }
    handleButtonClick = data => {
        let { handleButtonClick } = this.props;
        handleButtonClick(data);
    };
    render() {
        let { dataList, singleSelection, updateSelected } = this.props;
        let handleButtonClick = this.handleButtonClick;
        return (
            <DataTable
                id="trustListGrid"
                columns={[
                    {
                        title: 'Name',
                        data: 'name'
                    },
                    {
                        title: 'Edgar Cik',
                        data: 'edgarCik'
                    },
                    {
                        title: 'Client Code',
                        data: 'clientCode'
                    },
                    {
                        title: 'Federal ID',
                        data: 'federalId'
                    },
                    {
                        title: 'Review',
                        data: null
                    }
                ]}
                data={dataList}
                singleSelection={singleSelection}
                onSelectedItems={data => {
                    updateSelected(data[0]);
                }}
                columnFormat={[
                    {
                        targets: [-1],
                        width: '8%',
                        className: 'text-center',
                        render: function(data, type, full) {
                            return '<span class="label label-default" style="cursor: pointer; font-size: 90%">Review</span>';
                        },
                        createdCell: function(td, cellData, rowData, row, col) {
                            let data = cellData;
                            $(td).click(cellData => {
                                handleButtonClick(data);
                            });
                        }
                    }
                ]}
                rowFormat={(row, data, dataIndex) => {
                    if (singleSelection) {
                        $(row).css('cursor', 'pointer');
                    }
                }}
            />
        );
    }
}

TrustListGrid.propTypes = {
    dataList: PropTypes.array.isRequired,
    singleSelection: PropTypes.bool,
    updateSelected: PropTypes.func,
    handleButtonClick: PropTypes.func
};

TrustListGrid.defaultProps = {
    singleSelection: false,
    updateSelected: () => {}
};

export default TrustListGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/PendingSecurities/TrustListGrid.js